import React, { useEffect, useState } from "react";
import ItemConfigDetails from "../components/Item_Configuration_Page/ItemConfigDetails";
import ItemConfigForm from "../components/Item_Configuration_Page/ItemConfigForm";
import DashboardNavBar from "../components/NavBar/DashboardNavBar";
import Footer from "../components/Shared/Footer";
import { useItemConfigContext } from "../hooks/useContext/useItemConfigContext";
import { useAuthContext } from "../hooks/useContext/useAuthContext";
import { Grid, Box, Tabs, Tab } from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';

const GridContainerMain = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.common.background,
  paddingLeft: "80px",
  paddingRight: "80px",
  paddingTop: "70px",
  width: "100%",
  minHeight: "100vh",
  "@media (max-width: 960px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "35px",
  },
}));

const MenuItemsPage = () => {
  const { itemConfigs, dispatch } = useItemConfigContext();
  const { user } = useAuthContext();
  const [tabValue, setTabValue] = useState('all');
  const theme = useTheme();
  
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };


  useEffect(() => {
    const fetchItemConfigs = async () => {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/itemconfigs", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();
      if (response.ok) {
        dispatch({ type: "SET_ITEMCONFIG", payload: json });
      } else {
        window.location.reload();
      }
    };

    if (user) {
      fetchItemConfigs();
    }
  }, [dispatch, user]);

  const filterItems = () => {
    if (!itemConfigs) return [];

    let filteredItems = itemConfigs;
    if (tabValue !== 'all') {
      filteredItems = itemConfigs.filter(item => item.itemType === tabValue.charAt(0).toUpperCase() + tabValue.slice(1));
    } else {
      // Sorting logic when 'all' tab is selected
      const typeOrder = { 'Jedzenie': 1, 'Napoje': 2, 'Napoje Alkoholowe': 3 };
      filteredItems.sort((a, b) => typeOrder[a.itemType] - typeOrder[b.itemType]);
    }
    
    return filteredItems;
  };

  return (
    //allows drag and drop on screen
    // <DndProvider backend={HTML5Backend}>
    <div style={{backgroundColor: theme.palette.common.background}}>
      <DashboardNavBar />
      <GridContainerMain container spacing={{xs:3, sm:3, md:3, lg:4, xl:6}}>
        <Grid item xs={12} sm={12} md={12} lg={7} xl={8} order={{ xs: 2, lg: 1 }}>
          <Tabs value={tabValue} onChange={handleChange} centered sx={{ width: '100%', marginBottom: '1rem' }}>
            <Tab label="All" value="all" />
            <Tab label="Jedzenie" value="Jedzenie" />
            <Tab label="Napoje" value="Napoje" />
            <Tab label="Napoje Alkoholowe" value="Napoje Alkoholowe" />
          </Tabs>
          <Grid container spacing={3}>
            {filterItems().map((itemConfig) => (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={itemConfig._id}>
                <ItemConfigDetails key={itemConfig._id} itemConfig={itemConfig} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={5} xl={4} order={{ xs: 1, lg: 2 }}>
          <ItemConfigForm />
        </Grid>
      </GridContainerMain>
      <Footer />
    </div>
    // </DndProvider>
  );
};

export default MenuItemsPage;